import { LabelStyled } from './Label.styles'

const Label = LabelStyled

export default Label
